import { listContenidoItems } from "./contenidoOrden";
import { displayArchivoNombre } from "./archivoDisplayName";
import {
  listLinkedTestTitles,
  temarioChildDuplicatesLinkedTests,
  temarioNodeHasVisibleContent,
} from "./campusVisibleContent";

/**
 * Builds accordion card rows for a top-level campus block.
 * Prefer real children; otherwise synthesize rows from the leaf's own files/tests.
 *
 * @param {Record<string, unknown> | null | undefined} bloque
 * @param {number} blockIndex
 * @returns {Array<{
 *   kind: "node" | "archivo" | "testRef",
 *   rowKey: string,
 *   navPath: number[],
 *   node: Record<string, unknown>,
 *   archivo?: Record<string, unknown>,
 *   testRef?: Record<string, unknown>,
 * }>}
 */
export function buildAccordionResourceRows(bloque, blockIndex) {
  const index = Number(blockIndex);
  const safeIndex = Number.isFinite(index) ? index : 0;
  const hijos = Array.isArray(bloque?.hijos) ? bloque.hijos : [];
  const linkedTestTitles = listLinkedTestTitles(bloque);

  const childRows = hijos.flatMap((hijo, childIdx) => {
    if (!temarioNodeHasVisibleContent(hijo) || temarioChildDuplicatesLinkedTests(hijo, linkedTestTitles)) {
      return [];
    }
    return [{
      kind: "node",
      rowKey: `node-${safeIndex}-${childIdx}`,
      navPath: [safeIndex, childIdx],
      node: hijo && typeof hijo === "object" ? hijo : { nombre: "—" },
    }];
  });

  /** @type {ReturnType<typeof buildAccordionResourceRows>} */
  const rows = [];

  listContenidoItems(bloque).forEach((item) => {
    if (item.kind === "archivo") {
      const archivo = item.archivo;
      const name = displayArchivoNombre(archivo, `Archivo ${item.sourceIndex + 1}`);
      rows.push({
        kind: "archivo",
        rowKey: `archivo-${safeIndex}-${item.sourceIndex}`,
        navPath: [safeIndex],
        archivoIndex: item.sourceIndex,
        archivo: archivo && typeof archivo === "object" ? archivo : {},
        node: {
          nombre: name,
          archivos: [archivo],
          testRefs: [],
          contenidoOrden: archivo?.nombre
            ? [{ kind: "archivo", nombre: String(archivo.nombre) }]
            : [],
          hijos: [],
        },
      });
      return;
    }
    const testRef = item.testRef;
    const title =
      testRef && typeof testRef === "object" && typeof testRef.titulo === "string" && testRef.titulo.trim()
        ? testRef.titulo
        : `Test ${item.sourceIndex + 1}`;
    rows.push({
      kind: "testRef",
      rowKey: `test-${safeIndex}-${item.sourceIndex}`,
      navPath: [safeIndex],
      testRef: testRef && typeof testRef === "object" ? testRef : {},
      node: {
        nombre: title,
        archivos: [],
        testRefs: [testRef],
        contenidoOrden: [{ kind: "test", titulo: title }],
        hijos: [],
      },
    });
  });

  return [...rows, ...childRows];
}
